import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectIsOpen } from '../../../selectors/searchResults';
import { useMapContext } from '../context';

const SIDEBAR_WIDTH = 320;

export const MapMarginManager: React.FC = () => {
  const { map } = useMapContext();
  const isSidebarOpen = useSelector(selectIsOpen);
  const currentMarginRef = React.useRef<YMaps.map.margin.Accessor | null>(null);

  React.useEffect(() => {
    if (currentMarginRef.current) {
      currentMarginRef.current.remove();
    }

    if (isSidebarOpen) {
      currentMarginRef.current = map.margin.addArea({ top: 0, left: 0, width: SIDEBAR_WIDTH, height: '100%' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSidebarOpen]);

  return null;
};
